const calculatePercentage = (value) => Math.round(value * 100 * 100) / 100 || 0;

export { calculatePercentage };
